<template>
    <BasicModal :title="title" @close="$emit('close')">
        <p>{{ message }}</p>
        <div class="actions">
            <Bttn class="outlined" @click="$emit('close')">
                {{ cancelLabel }}
            </Bttn>
            <Bttn ref="confirmButton" @click="$emit('confirm')">
                {{ confirmLabel }}
            </Bttn>
        </div>
    </BasicModal>
</template>

<script>
import BasicModal from "js/components/modals/BasicModal";

export default {
    name: "ConfirmModal",
    components: { BasicModal },
    props: {
        title: {
            type: String,
            default: "Are you sure?",
        },
        message: {
            type: String,
            required: true,
        },
        confirmLabel: {
            type: String,
            default: "Confirm",
        },
        cancelLabel: {
            type: String,
            default: "Cancel",
        },
    },
    emits: ["close", "confirm"],
    mounted() {
        this.$refs.confirmButton.$el.focus();
    },
};
</script>
